import { SxProps } from "@mui/material"

export const KeyDriveButtonDefaultStyles: SxProps = {
    width: "260px",
    height: "36px",
    backgroundColor: "#22638D"
}

export const KeyDriveButtonDefaultStylesWithoutBackground: SxProps = {
    width: "260px",
    height: "36px",
}